import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    VEHICLE_LIST,
    VEHICLE_DETAIL,
    VEHICLE_ADD,
    VEHICLE_UPDATE
} from '../actions';
import {
    VehicleListSuccess,
    VehicleListError,
    VehicleDetailSuccess,
    VehicleDetailError,
    VehicleAddSuccess,
    VehicleAddError,
    VehicleUpdateSuccess,
    VehicleUpdateError
} from '../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

// LIST
const onVehicleListAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'vehicle/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onVehicleList(action) {
    try {
        const response = yield call(onVehicleListAsync, action.payload);
        yield put(VehicleListSuccess(response.data));
    } catch (error) {
        yield put(VehicleListError(error));
    }
}

// DETAIL
const onVehicleDetailAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'vehicle/detail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onVehicleDetail(action) {
    try {
        const response = yield call(onVehicleDetailAsync, action.payload);
        yield put(VehicleDetailSuccess(response.data.data));
    } catch (error) {
        yield put(VehicleDetailError(error));
    }
}

// ADD
const onVehicleAddAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'vehicle/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onVehicleAdd(action) {
    try {
        const response = yield call(onVehicleAddAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else {
            NotificationManager.error(response.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(VehicleAddSuccess(response.data.id));
    } catch (error) {
        yield put(VehicleAddError(error));
        NotificationManager.error('Error al agregar vehículo', 'Error', 3000, null, null, '');
    }
}

// UPDATE
const onVehicleUpdateAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'vehicle/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onVehicleUpdate(action) {
    try {
        const response = yield call(onVehicleUpdateAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else {
            NotificationManager.error(response.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(VehicleUpdateSuccess(response.data));
    } catch (error) {
        yield put(VehicleUpdateError(error));
        NotificationManager.error('Error al actualizar vehículo', 'Error', 3000, null, null, '');
    }
}

function* watchVehicleList() { yield takeEvery(VEHICLE_LIST, onVehicleList); }
function* watchVehicleDetail() { yield takeEvery(VEHICLE_DETAIL, onVehicleDetail); }
function* watchVehicleAdd() { yield takeEvery(VEHICLE_ADD, onVehicleAdd); }
function* watchVehicleUpdate() { yield takeEvery(VEHICLE_UPDATE, onVehicleUpdate); }

export default function* rootSaga() {
    yield all([
        fork(watchVehicleList),
        fork(watchVehicleDetail),
        fork(watchVehicleAdd),
        fork(watchVehicleUpdate)
    ]);
}
